import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';
import actionCreatorFactory from 'typescript-fsa';
import { makeProductTourActions } from './actions';

export * from './components';
export * from './hooks';
export * from './selectors';

const name = '@insights-gaming/product-tour';
const actionCreators = actionCreatorFactory(name);

type ProductTourId = string;

export interface ProductTourState {
  viewedProductTours: Partial<Record<string, boolean>>;
  viewedProductToursLoaded: boolean;
}

export function makeProductTourSlice<T extends ProductTourId>(
  config: {
    extraReducers?: (builder: ActionReducerMapBuilder<ProductTourState>, actions: ReturnType<typeof makeProductTourActions>) => void;
  },
) {
  const {
    extraReducers,
  } = config;

  const productTourActions = makeProductTourActions(actionCreators);

  const initialState: ProductTourState = {
    viewedProductTours: {},
    viewedProductToursLoaded: false,
  };

  const productTourSlice = createSlice({
    name,
    initialState,
    reducers: {
      productTourViewed(state, action: PayloadAction<T>) {
        state.viewedProductTours[action.payload] = true;
      },
    },
    extraReducers: builder => {
      const async = productTourActions.loadViewedProductTourDatabaseAC;
      builder.addCase(async.done, (state, action) => {
        const { result } = action.payload;
        state.viewedProductTours = Object.fromEntries(result.map(tourId => [tourId, true]));
        state.viewedProductToursLoaded = true;
      });

      if (extraReducers) {
        extraReducers(builder, productTourActions);
      }
    },
  });

  return {
    productTourActions,
    productTourSlice,
  };
}
